import { Component, OnInit } from '@angular/core';
import { ColumnHeader } from 'src/app/models/column-header';
import { CommonService } from 'src/app/services/common-service/common.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Labels } from 'src/app/constants/labels';
import { RoutePath } from 'src/app/constants/routerPath';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ConfirmModalComponent } from 'src/app/components/modal/confirm-modal/confirm-modal.component';
import { KEYS } from 'src/app/constants/keys';
import { isData } from 'src/app/utils/utils';
import { SrcPath } from 'src/app/constants/srcPath';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.scss'],
  imports: [SharedModule, CommonModule]
})
export class AdminDashboardComponent implements OnInit {

  headerData: ColumnHeader | any;
  pageListData: any;
  labelMessages = Labels.messages;
  labelPage = Labels.dashboard;
  labelButton = Labels.buttons;
  bsModalRef!: BsModalRef;
  isSuperaDmin: boolean = false;
  dbPath: any;
  dashboardListData: any;
  srcPath = SrcPath;
  adminMenuIcon = SrcPath.adminMenuIcon;
  messageLabel = Labels.messages;

  constructor(private commonService: CommonService,
    private router: Router,
    private toastr: ToastrService,
    private modalService: BsModalService) {
  }

  ngOnInit(): void {
    this.isSuperAdmin();
    this.initHeaderColumn();
    this.getDashboardListData();
  }
  isSuperAdmin() {
    this.isSuperaDmin = JSON.parse(sessionStorage.getItem(KEYS.isSuperAdmin)!);
    if (this.isSuperaDmin) {
      this.dbPath = JSON.parse(sessionStorage.getItem(KEYS.customerDbPath)!);
    }
  }
  private initHeaderColumn() {
    this.headerData = {
      title: this.labelPage.dashboard_reports,
      button: {
        show: true,
        name: this.labelButton.create_new_dashboard
      },
      topButton: {
        show: false
      }
    };
  }

  viewPage(data: any) {
    this.router.navigate([RoutePath.dashboardPageLayout, data.gstibo_menu_name],
      {
        queryParams: {
          Id: data['gstibo_dashboard_id'],
          Details: JSON.stringify(data)
        }
      });
    // this.router.navigate([RoutePath.dashboardPageLayout, data.gstibo_menu_name]);
    // this.router.navigate(['/dashboard-user']);
  }

  editPage(data: any) {
    let dbFullPath = this.isSuperaDmin == true ? this.dbPath : '';
    this.router.navigate([RoutePath.createNewDashboard],
      {
        queryParams: {
          Id: data['gstibo_dashboard_id'],
          Details: JSON.stringify(data)
        }
      });
  }

  deletePage(dashboardId: any) {
    let ipaddress = '', machinename = '';
    let dbFullPath = this.isSuperaDmin == true ? this.dbPath : '';
    this.bsModalRef = this.modalService.show(ConfirmModalComponent, {
      animated: true, class: KEYS.confirmModal
    });
    this.bsModalRef.content.data = {
      title: this.labelMessages.delete_confirm_msg.title,
      message: this.labelMessages.delete_confirm_msg.message,
      btnConfirm: this.labelMessages.delete_confirm_msg.btnDelete,
      btnCancel: this.labelMessages.delete_confirm_msg.btnCancel,
      btnConfirmStyle: 'btn-red',
      btnCancelStyle: 'btn-green'
    }
    this.bsModalRef.content.buttonevent.subscribe((res: any) => {
      if (res) {
        this.commonService.deleteAdminDashboard(dbFullPath, dashboardId, this.commonService.getUserCredentials(KEYS.credential_customer_id)).subscribe((data: any) => {
          this.getDashboardListData();
         // this.toastr.success(this.labelMessages.delete_success_msg.message);
          this.commonService.showModalValidate(this.labelMessages.delete_success_msg.message,'',this.messageLabel.static_messages.info,this.labelMessages.delete_success_msg.message);

        });
      }
    });
  }

  getDashboardListData() {
    let dbFullPath = this.isSuperaDmin == true ? this.dbPath : '';
    this.commonService.loadAdminDashboardList(dbFullPath).subscribe((data: any) => {
      this.commonService.ogLog('data : ', data['table']);
      this.dashboardListData = data['table'];
    });
  }

}
